<template>
    <Modal id="waiver-code-modal"
           icon="fa-qrcode"
           title="WAIVER_CODE.MODAL_TITLE"
           size="sm">
        <a :href="waiverLink"
           target="_blank">
            <QRCode :content="waiverLink"
                    :width="250" />
        </a>

        <div v-if="shownOnCustomerScreen"
             class="alert alert-info">
            <i class="fa-solid fa-info-circle"></i> {{ l('WAIVER_CODE.SHOWN_TO_CUSTOMER') }}
        </div>

        <template v-slot:footer>
            <div class="modl-footer modl-footer--vertical">
                <SquareBtn class="desktop-only"
                           size="lg"
                           :color="shownOnCustomerScreen ? 'success' : 'info'"
                           :active="!!shownOnCustomerScreen"
                           @click="toggleOnCustomerScreen">
                    {{ shownOnCustomerScreenBtnText }}
                </SquareBtn>

                <SquareBtn class="desktop-only"
                           size="lg"
                           color="info"
                           :loading="printing"
                           @click="print">
                    {{ l('WAIVERS.PRINT_BTN') }}
                </SquareBtn>

                <SquareBtn size="lg"
                           @click="ok">
                    {{ l('CLOSE') }}
                </SquareBtn>
            </div>
        </template>
    </Modal>
</template>

<script>
import CustomerScreenQRCodeData from '@/lib/CustomerScreen/CustomerScreenQRCodeData';
import Modal from '@/vue/components/Modals/Modal';
import QRCode from '@/vue/components/QRCodes/QRCode';
import SquareBtn from '@/vue/components/SquareBtn';
import { container } from '@/container';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    components: { Modal, SquareBtn, QRCode },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        waiver: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            printing: false,
            shownOnCustomerScreen: false,
        };
    },

    computed: {
        waiverLink() {
            return this.waiver.getWaiverLink(container.appConfig);
        },

        shownOnCustomerScreenBtnText() {
            if (this.shownOnCustomerScreen) {
                return container.langService.getText('WAIVER_CODE.HIDE_ON_CUSTOMER_SCREEN__BTN');
            }

            return container.langService.getText('WAIVER_CODE.SHOW_ON_CUSTOMER_SCREEN__BTN');
        },
    },

    methods: {
        ok() {
            this.hideOnCustomerScreen();
            this.resolve();
        },

        print() {
            if (this.printing) {
                return;
            }

            this.printing = true;
            container.receiptPrinter
                .printWaiverLinkSlip(this.waiver)
                .finally(() => {
                    this.printing = false;
                });
        },

        toggleOnCustomerScreen() {
            if (this.shownOnCustomerScreen) {
                this.hideOnCustomerScreen();
            } else {
                this.showOnCustomerScreen();
            }
        },

        showOnCustomerScreen() {
            container.customerScreenDataService.showQRCode(
                new CustomerScreenQRCodeData({
                    content: this.waiverLink,
                })
            );
            this.shownOnCustomerScreen = true;
        },

        hideOnCustomerScreen() {
            container.customerScreenDataService.hideQRCode();
            this.shownOnCustomerScreen = false;
        },
    },
};
</script>

<style lang="less">
#waiver-code-modal {
    .qr-code {
        margin: 20px;
        text-align: center;
    }
}
</style>
